import { createFileRoute } from "@tanstack/react-router";

import { canManageOrg } from "@/core/lib/access";
import { denyRouteAccess } from "@/core/lib/route-access";
import { dataResourcePageSearchSchema } from "@/features/datasource/lib/data-resource-search";

export const Route = createFileRoute("/_protected/data/databases")({
  validateSearch: dataResourcePageSearchSchema,
  beforeLoad: ({ context, ...guard }) => {
    if (!canManageOrg(context.user)) {
      denyRouteAccess(guard, "org_admin");
    }
  },
});
